export const siteNav = [
  { label: '首页', to: '/' },
  { label: '频道列表', to: '/channels' },
  { label: '专题分类', to: '/topics' },
  { label: '内容板块', to: '/#sections' },
  { label: '关于我们', to: '/about' },
];

export const siteStats = [
  { value: '10', unit: '个', label: '内容频道', desc: '覆盖娱乐、科技、财经到民生维权' },
  { value: '6', unit: '类', label: '专题方向', desc: '按主题横向聚合全站内容' },
  { value: '8600', unit: '篇', label: '累计发布', desc: '持续更新的爆料与调查内容' },
  { value: '128', unit: '万', label: '月度读者', desc: '来自各频道的长期订阅用户' },
];

export const testimonials = [
  {
    name: '周',
    role: '消费维权频道读者',
    text: '按维权指南里的步骤整理证据，一次沟通就把售后问题解决了，比之前反复打电话有效得多。',
  },
  {
    name: '李',
    role: '科技内幕频道读者',
    text: '很喜欢频道分类的方式，我只订阅科技和汽车两个频道，首页推荐也不会塞满无关内容。',
  },
  {
    name: '陈',
    role: '投稿用户',
    text: '投稿后编辑主动联系核实了几个细节，最后发出来的版本时间线很清楚，没有添油加醋。',
  },
];

export const contactInfo = {
  email: 'editor@baoliao-gw.com',
  replyTime: '工作日 24 小时内回复',
  cooperation: 'cooperate@baoliao-gw.com',
  brand: '爆料官网',
  slogan: '把每一条线索，讲成看得懂的事实',
};